import Logging from "../Logging.js";
import StateStoreBase from "./StateStoreBase.js";
class ProcessingStore extends StateStoreBase {
  constructor() {
    super(...arguments);
    this.isLoadingPage = true;
    this.maskMenu = false;
    this.processingCount = 1;
  }
  get isMenuMasked() {
    return this.maskMenu;
  }
  get() {
    return this.processingCount !== 0;
  }
  pageLoadingStarted({ maskMenu } = {}) {
    if (this.isLoadingPage) {
      return;
    }
    this.isLoadingPage = true;
    this.maskMenu = maskMenu ?? false;
    this.processingStarted();
  }
  pageLoadingStopped() {
    window.setTimeout(() => {
      if (!this.isLoadingPage) {
        return;
      }
      this.isLoadingPage = false;
      this.maskMenu = false;
      this.processingStopped();
    });
  }
  processingStarted() {
    this.processingCount++;
    if (this.processingCount === 1) {
      this.notifySubscribers();
    }
  }
  processingStopped() {
    if (this.processingCount === 0) {
      void Logging.warning(
        "processingStopped called without processingStarted"
      );
      return;
    }
    this.processingCount--;
    if (this.processingCount === 0) {
      this.notifySubscribers();
    }
  }
}
const processingStore = new ProcessingStore();
export {
  ProcessingStore,
  processingStore as default
};
//# sourceMappingURL=processingStore.js.map
